export default __webpack_public_path__ + "static/media/pagination-right.926b877a.svg";